import { loadScript, cookie } from '@ifeng-fe/ui_base';
import copy from 'copy-to-clipboard';

/**
 * @视频客户端schemes参数说明：
 *   ifengVideoPlayer://[type]/[id]/[guid]/[channel]?k1=v1&k2=v2&k3=v3
 *       type: video/live/vrlive , 跳转类型
 *       id: 页面数据id
 *       guid: video-guid / live-channelId
 *       channel: h5/sf , 跳转渠道
 *       k1=v1&k2=v2&k3=v3: 其他额外参数
 *   注：拉起到客户端首页使用ifengVideoPlayer://
 */

const ua = typeof navigator === 'object' ? navigator.userAgent : '';
const getDevice = () => {
    return {
        isWeixin: ua.match(/MicroMessenger/gi),
        isQQ: ua.match(/QQ\//),
        isPC: !/iphone|ipod|ipad|android/gi.test(ua),
        isAlipay: ua.match(/Alipay/),
        isWeibo: ua.match(/WeiBo/i),
        isBaidu: ua.match(/baidu/gi),
        isAndroid: ua.match(/android/gi),
        isIos: ua.match(/iphone|ipod/gi),
        isIpad: ua.match(/ipad/gi),
    };
};

// 拉起视频客户端的api
const callVideoApi = {
    commoncall: 'ifengVideoPlayer://', // ifengVideoPlayer://[type]/[id]/[guid]/[channel]?k1=v1&k2=v2&k3=v3
    wxcall: {
        ios: 'https://api.iclient.ifeng.com/wakeupiOS/video/ifengplayer?type=[type]&id=[id]&kind=[channel]',
        android: '[down]&android_scheme=[common]&kind=[channel]',
    },
};

const downloadUrl = {
    download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.newvideo&ckey=CK1351861306533',
    downloadAd: 'http://api.3g.ifeng.com/ifengvideo_tg34?vt=5',
    // protocolApi: 'comifengnewsclient://call'
};

const handleVideoUrl = obj => {
    let url = callVideoApi.commoncall;
    const search = [];

    if (JSON.stringify(obj.scheme) !== '{}') {
        // 处理schema
        url = `${url}${obj.scheme.type}/${obj.scheme.id ? `${obj.scheme.id}/` : ''}${
            obj.scheme.guid ? `${obj.scheme.guid}/` : ''
        }${obj.scheme.channel}`;
        if (JSON.stringify(obj.search) !== '{}') {
            // 处理?之后的参数
            for (const h in obj.search) {
                search.push(`${h}=${obj.search[h]}`);
            }
            url = `${url}?${search.join('&')}`;
        }
    }

    return url;
};

const callVideoAPP = (param, ifdown) => {
    let url = handleVideoUrl(param);
    const ua = getDevice();
    const log = '';

    if (ua.isWeixin || ua.isQQ || ua.isWeibo || ua.isAlipay) {
        // QQ/微信/微博
        if (ua.isIos && !ua.isWeixin) {
            // ios 但不是微信
            url = callVideoApi.wxcall.ios;
            if (!ifdown) {
                // 不跳下载
                url += '&scheme=1';
            }
            url = url.replace('[type]', param.scheme.type).replace('[channel]', param.scheme.channel);

            const idstr = [];

            if (param.scheme.id) {
                idstr.push(param.scheme.id);
            }
            if (param.scheme.guid) {
                idstr.push(param.scheme.guid);
            }
            if (param.search && param.search.vrURL) {
                idstr.push(encodeURIComponent(`vrURL=${param.search.vrURL}`));
            }

            url = url.replace('[id]', idstr.join('|||'));

            // 微信拉起直接到应用宝下载页面
        } else if (ua.isIos && ua.isWeixin) {
            // 如果是微信
            // location.href = param.down[0];
        } else {
            // android
            const common = url;

            url = callVideoApi.wxcall.android;
            url = url.replace('[down]', param.down[0]).replace('[channel]', param.scheme.channel);
            url = url.replace('[common]', encodeURIComponent(common));
        }
    }
    if (ua.isIos && ua.isWeixin) {
        const clip_text = `ifengVideoPlayer://video/${param.scheme.guid ? param.scheme.guid : ''} /sf`;

        copy(clip_text);
    } else {
        window.setTimeout(() => {
            location.href = url;
        }, 200);
    }
    // 下载
    if (document.hasFocus()) {
        let down = '';

        if (ua.isWeixin || ua.isQQ || ua.isWeibo || ua.isAlipay) {
            // QQ或微信
            down = downloadUrl.download;
        } else {
            down = downloadUrl.downloadAd;
        }
        // 调试日志
        // alert('down:' + down);
        window.setTimeout(() => {
            if (document.hasFocus()) {
                location.href = down;
            }
        }, 500);
    }
};

// 拉起拉活
const handleCallVideoApp = () => {};

const getScript = async (url, callback) => {
    await loadScript(url, { cache: false, reload: false });

    if (callback) callback();
};

const getUserid = () => {
    return cookie.get('userid');
};

const getSid = () => {
    return cookie.get('sid');
};

export { callVideoAPP, handleCallVideoApp, getScript, getUserid, getSid };
